import React from 'react'

function Links() {
  return (
    <div className='links'>
      <a href="https://www.linkedin.com/in/anna-harbour-43bab8231/" target="_blank" rel="noreferrer noopener"><i className="fa-brands fa-linkedin"></i></a>
      <a href="https://github.com/AnnaHarbour" target="_blank" rel="noreferrer noopener"><i className="fa-brands fa-square-github"></i></a>
      <a href="https://www.instagram.com/anna.harbour/" target="_blank" rel="noreferrer noopener"><i className="fa-brands fa-square-instagram"></i></a>
      <a href="https://www.facebook.com/annaharbour123/" target="_blank" rel="noreferrer noopener"><i className="fa-brands fa-square-facebook"></i></a>
      <a href="https://twitter.com/AnnaHarbour" target="_blank" rel="noreferrer noopener"><i className="fa-brands fa-square-twitter"></i></a>
    </div>
  )
}

export default Links